import React from 'react'
import "./EscapeHelper.css"
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Typography } from '../../design_system/StyledComponents/components/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveRoomIndex, setEscapeMessageShow, setExpandRoomNamePopup, setRoomDetails, setRoomEditingMode, setRoomName, setSelectedLinesState } from '../../Actions/ApplicationStateAction';
import WallIcon from "../../assets/wallBig.png";
import DoorIcon from "../../assets/doorBig.png";
import WindowIcon from "../../assets/windowBig.png";
import RailingIcon from "../../assets/railingBig.png"
import divide from "../../assets/WallOpening.png"
import { Close } from '@mui/icons-material';
import useModes from '../../hooks/useModes';
import {handleReset} from '../../component/Overlays/RoomNamePopup.js'
import {
  setActiveRoomButton,
} from "../../Actions/ApplicationStateAction.js";
import { setEnablePolygonSelection, updateTemoraryPolygon } from '../../Actions/DrawingActions';

const EscapeHelper = () => {
  const {typeId} = useSelector((state) => state.Drawing);
  
  const {activeRoomButton, designStep} = useSelector((state) => state.ApplicationState);

  const { toggleSelectionMode } = useModes(); 
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(setEscapeMessageShow(false));
        window.GAEvent("DrawTool", "EscapeHelper", "DontShowAgain");
    }

    const handleStopDrawing = () => {
      window.GAEvent("DrawTool", "EscapeHelper", "StopDrawing");
      if(activeRoomButton!="" && designStep===3){
        dispatch(setActiveRoomButton(""));
        //--
            dispatch(setRoomDetails(""));
            dispatch(setRoomName(""));
            dispatch(setRoomEditingMode(false));
            dispatch(setActiveRoomIndex(-1));
            dispatch(setSelectedLinesState([]));
            dispatch(setExpandRoomNamePopup(false));
            dispatch(updateTemoraryPolygon([]))
        //--
        dispatch(setEnablePolygonSelection(false))
        dispatch(updateTemoraryPolygon([]))
        return
      }
      toggleSelectionMode();
    }
    const data = {
      1: <img src={WallIcon} alt="Wall"  className='escape-helper-icon'/>,
      2: <img src={DoorIcon} alt="Door" className='escape-helper-icon'/>,
      3: <img src={WindowIcon} alt="Window" className='escape-helper-icon'/>,
      4: <img src={RailingIcon} alt="Railing" className='escape-helper-icon'/>,
      5: <img src={divide} alt="Divide" className='escape-helper-icon'/>
    };
    

  return (
    <div className='escape-helper-container'>
      <div className='escape-helper-content'>
        {data[typeId || 1]}

        <Typography modifiers={["subtitle3", "medium"]}>
          
          {
            (activeRoomButton!="" && designStep===3) ?
              activeRoomButton=="add"? "Adding new room" : 
                activeRoomButton=="divide"? "Dividing room": "Drawing mode active" 
            : "Drawing mode active"
          }
        </Typography>
        {/* <NotificationsIcon style={{marginRight: "16px"}}/>
        <Typography>Press&nbsp;</Typography>
        <div className='escape-helper-escape'><Typography>Esc</Typography></div>
        <Typography>&nbsp;to exit drawing</Typography> */}
      </div>
      <div className='escape-helper-right' onClick={handleStopDrawing}>
        {/* <Typography onClick={handleClick} modifiers={["blue"]}>Don't show again</Typography> */}
        <Close/>
        <Typography modifiers={["subtitle3", "bold"]}>
          {
            (activeRoomButton!="" && designStep===3) ?
              "Cancel" : "Stop drawing" 
          }
          
          
          </Typography>
      </div>
    </div>
  )
}

export default EscapeHelper
